module.exports = __webpack_public_path__ + "img/IMG_6911.edb1f5bb.webp";